var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Your-home-Copy-82",
    transform: "translate(-337.000000, -212.000000)",
    fill: "#D8D7D6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.707107,212.792893 L342.949,217.035 L347.192388,212.792893 C347.582912,212.402369 348.216077,212.402369 348.606602,212.792893 C348.997126,213.183418 348.997126,213.816582 348.606602,214.207107 L344.364,218.449 L348.606602,222.692388 C348.997126,223.082912 348.997126,223.716077 348.606602,224.106602 C348.216077,224.497126 347.582912,224.497126 347.192388,224.106602 L342.949,219.864 L338.707107,224.106602 C338.316582,224.497126 337.683418,224.497126 337.292893,224.106602 C336.902369,223.716077 336.902369,223.082912 337.292893,222.692388 L341.535,218.449 L337.292893,214.207107 C336.902369,213.816582 336.902369,213.183418 337.292893,212.792893 C337.683418,212.402369 338.316582,212.402369 338.707107,212.792893 Z",
    id: "Combined-Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b73a25e63cb6bd40574ddc7f427b87d3.svg";
export { ForwardRef as ReactComponent };